import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Data } from '@angular/router';
import * as Crypto from 'crypto-js';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {
  constructor(private http: HttpClient) {
    this.userData = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  }


  userData: any;
  baseURL = environment.baseURL;

  resourceCount: BehaviorSubject<any> = new BehaviorSubject('');
  public isCommunication: any = new BehaviorSubject('');
  public notificationClicked: any = new BehaviorSubject('');
  public isMarkAllRead: any = new BehaviorSubject(false);
  formComponentData: BehaviorSubject<any> = new BehaviorSubject({});

  data = this.resourceCount.asObservable();

   prefillIpsaForm = this.formComponentData.asObservable();

  // Dashboard Page variables start
  districtBoundaries: any;

  formIoBaseURL = 'https://stgformbuilder-latest.dhwaniris.in/#/';

  jsonSchema: any = {
    0: {
        title: 'Social Infrastructure',
        collapsible: false,
        key: 'socialInfrastructure',
        type: 'panel',
        label: 'Panel',
        input: false,
        tableView: false,
        components: [
            {
                label: 'Social Infrastructure',
                components: [
                    {
                        label: 'Social Infrastructure',
                        key: 'socialInfrastructure',
                        components: [
                            {
                                label: 'Subtabs',
                                components: [
                                    {
                                        label: 'Worker accommodation',
                                        key: 'workerAccommodation',
                                        components: [
                                            {
                                                title: 'Worker accommodation',
                                                collapsible: false,
                                                key: 'workerAccommodation1',
                                                type: 'panel',
                                                label: 'Panel',
                                                input: false,
                                                tableView: false,
                                                components: [
                                                    {
                                                        label: 'Does the Industrial Park have any initiatives or programmes to support its workers access decent affordable housing near the Industrial Park? For example, a rental coupon system, housing allowance etc ?',
                                                        widget: 'choicesjs',
                                                        tableView: true,
                                                        data: {
                                                            values: [
                                                                {
                                                                    label: 'No',
                                                                    value: '1'
                                                                },
                                                                {
                                                                    label: 'Demonstrates awareness of requirement',
                                                                    value: '2'
                                                                },
                                                                {
                                                                    label: 'Evidence of a plan in place towards full compliance',
                                                                    value: '3'
                                                                },
                                                                {
                                                                    label: 'Fully compliant',
                                                                    value: '4'
                                                                },
                                                                {
                                                                    label: 'N/A',
                                                                    value: 'N/A'
                                                                }
                                                            ]
                                                        },
                                                        validate: {
                                                            required: true
                                                        },
                                                        key: 'doesTheIndustrialParkHaveAnyInitiativesOrProgrammesToSupportItsWorkersAccessDecentAffordableHousingNearTheIndustrialParkForExampleARentalCouponSystemHousingAllowanceEtc',
                                                        type: 'select',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'Please specify',
                                                        placeholder: 'Enter your comment',
                                                        applyMaskOn: 'change',
                                                        tableView: true,
                                                        key: 'pleaseSpecify',
                                                        type: 'textfield',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'br',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html1',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'hr',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html2',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'br',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'Does the Industrial Park have access to a suitable and sufficient land area to develop social housing?.',
                                                        widget: 'choicesjs',
                                                        tableView: true,
                                                        data: {
                                                            values: [
                                                                {
                                                                    label: 'No',
                                                                    value: '1'
                                                                },
                                                                {
                                                                    label: 'Demonstrates awareness of requirement',
                                                                    value: '2'
                                                                },
                                                                {
                                                                    label: 'Evidence of a plan in place towards full compliance',
                                                                    value: '3'
                                                                },
                                                                {
                                                                    label: 'Fully compliant',
                                                                    value: '4'
                                                                },
                                                                {
                                                                    label: 'N/A',
                                                                    value: 'N/A'
                                                                }
                                                            ]
                                                        },
                                                        validate: {
                                                            required: true
                                                        },
                                                        key: 'doesTheIndustrialParkHaveAnyInitiativesOrProgrammesToSupportItsWorkersAccessDecentAffordableHousingNearTheIndustrialParkForExampleARentalCouponSystemHousingAllowanceEtc1',
                                                        type: 'select',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'Please specify',
                                                        placeholder: 'Enter your comment',
                                                        applyMaskOn: 'change',
                                                        tableView: true,
                                                        key: 'pleaseSpecify1',
                                                        type: 'textfield',
                                                        input: true
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        label: 'Accessibility',
                                        key: 'accessibility',
                                        components: [
                                            {
                                                title: 'Accessibility',
                                                collapsible: false,
                                                key: 'accessibility1',
                                                type: 'panel',
                                                label: 'Panel',
                                                input: false,
                                                tableView: false,
                                                components: [
                                                    {
                                                        label: 'Are there working street lights from the Industrial Park to public transport drop off/pick up points?',
                                                        widget: 'choicesjs',
                                                        tableView: true,
                                                        data: {
                                                            values: [
                                                                {
                                                                    label: 'No',
                                                                    value: '1'
                                                                },
                                                                {
                                                                    label: 'Demonstrates awareness of requirement',
                                                                    value: '2'
                                                                },
                                                                {
                                                                    label: 'Evidence of a plan in place towards full compliance',
                                                                    value: '3'
                                                                },
                                                                {
                                                                    label: 'Fully compliant',
                                                                    value: '4'
                                                                },
                                                                {
                                                                    label: 'N/A',
                                                                    value: 'Na'
                                                                }
                                                            ]
                                                        },
                                                        validate: {
                                                            required: true
                                                        },
                                                        key: 'areThereWorkingStreetLightsFromTheIndustrialParkToPublicTransportDropOffPickUpPoints',
                                                        type: 'select',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'Please specify',
                                                        placeholder: 'Enter your comment',
                                                        applyMaskOn: 'change',
                                                        tableView: true,
                                                        key: 'pleaseSpecify2',
                                                        type: 'textfield',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'br',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html5',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'hr',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html4',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'HTML',
                                                        tag: 'br',
                                                        attrs: [
                                                            {
                                                                attr: '',
                                                                value: ''
                                                            }
                                                        ],
                                                        refreshOnChange: false,
                                                        key: 'html3',
                                                        type: 'htmlelement',
                                                        input: false,
                                                        tableView: false
                                                    },
                                                    {
                                                        label: 'Is the Industrial Park located near public transportation (i.e., bus, subway or light- rail)?',
                                                        widget: 'choicesjs',
                                                        tableView: true,
                                                        data: {
                                                            values: [
                                                                {
                                                                    label: 'No',
                                                                    value: '1'
                                                                },
                                                                {
                                                                    label: 'Demonstrates awareness of requirement',
                                                                    value: '2'
                                                                },
                                                                {
                                                                    label: 'Evidence of a plan in place towards full compliance',
                                                                    value: '3'
                                                                },
                                                                {
                                                                    label: 'Fully compliant',
                                                                    value: '4'
                                                                },
                                                                {
                                                                    label: 'N/A',
                                                                    value: 'Na'
                                                                }
                                                            ]
                                                        },
                                                        validate: {
                                                            required: true
                                                        },
                                                        key: 'areThereWorkingStreetLightsFromTheIndustrialParkToPublicTransportDropOffPickUpPoints1',
                                                        type: 'select',
                                                        input: true
                                                    },
                                                    {
                                                        label: 'Please specify',
                                                        placeholder: 'Enter your comment',
                                                        applyMaskOn: 'change',
                                                        tableView: true,
                                                        key: 'pleaseSpecify3',
                                                        type: 'textfield',
                                                        input: true
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        label: 'Access control',
                                        key: 'accessControl',
                                        components: []
                                    },
                                    {
                                        label: 'Workplace amenities',
                                        key: 'workplaceAmenities',
                                        components: []
                                    }
                                ],
                                key: 'tabs',
                                type: 'tabs',
                                input: false,
                                tableView: false
                            }
                        ]
                    },
                    {
                        label: 'Occupational Health and Safety (OHS)',
                        key: 'occupationalHealth',
                        components: []
                    },
                    {
                        label: 'Indoor Environment',
                        key: 'indoorEnvironment',
                        components: []
                    }
                ],
                key: 'socialInfrastructure1',
                conditional: {
                    show: true
                },
                type: 'tabs',
                input: false,
                tableView: false
            }
        ]
    },
    1: {
        type: 'button',
        label: 'Submit',
        key: 'submit',
        disableOnInvalid: true,
        input: true,
        tableView: false
    },
    components: [
        {
            label: 'First Name',
            placeholder: 'Enter you first name',
            applyMaskOn: 'change',
            tableView: true,
            validate: {
                required: true,
                customMessage: '    <div class="col-sm-3"></div>',
                minLength: 2,
                maxLength: 20
            },
            errorLabel: 'Name field can not be empty !',
            key: 'firstName',
            type: 'textfield',
            input: true
        },
        {
            label: 'Last Name',
            placeholder: 'Enter you last name',
            applyMaskOn: 'change',
            tableView: true,
            validate: {
                required: true,
                customMessage: '    <div class="col-sm-3"></div>',
                minLength: 2,
                maxLength: 20
            },
            errorLabel: 'Name field can not be empty !',
            key: 'firstName3',
            type: 'textfield',
            input: true
        },
        {
            label: 'Email ID',
            placeholder: 'Enter you email id',
            applyMaskOn: 'change',
            tableView: true,
            validate: {
                required: true,
                customMessage: '    <div class="col-sm-3"></div>',
                minLength: 2,
                maxLength: 20
            },
            errorLabel: 'Name field can not be empty !',
            key: 'firstName2',
            type: 'textfield',
            input: true
        },
        {
            label: 'Password',
            placeholder: '**********',
            applyMaskOn: 'change',
            tableView: false,
            case: 'mixed',
            truncateMultipleSpaces: true,
            validate: {
                required: true,
                minLength: 8,
                maxLength: 15
            },
            key: 'password',
            type: 'password',
            input: true,
            protected: true
        },
        {
            type: 'button',
            label: 'Submit',
            key: 'submit',
            disableOnInvalid: true,
            input: true,
            tableView: false
        }
    ]
};

  updateResouceCount(data: Data): void {
    this.resourceCount.next(data);
   }

  updatePrefillIpsa(data: any): void {
    this.formComponentData.next(data);
   }
  // Dashboard Page variables end

  getToken(): string | null {
    // Get Token..
    return sessionStorage.getItem('token');
}

setHeadersJwt(): { headers: HttpHeaders } {
  const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || '',
      'x-jwt-token': sessionStorage.getItem('jwtToken') || ''
  });
  return { headers };
  }

  setHeaders(isCsv: boolean = false, type= ''): any {
    if (this.getToken()){
  const headers = new HttpHeaders({
      'x-access-token': sessionStorage.getItem('token') || '',
  });
  if (type === 'pdf'){
    headers.set('Content-Type', 'application/pdf');

  }
  else if (type === 'csv'){
    headers.set('Content-Type', 'text/plain; charset=utf-8');
  }
  else{
    headers.set('Content-Type', 'application/json');
  }
  const options: any = { headers };
  if (isCsv){
    options.responseType = 'text';
  }
  return options;
}
}
setHeadersCaptcha(): { headers: HttpHeaders } {
  const headers = new HttpHeaders({
      'Content-Type': 'application/json',
  });
  return { headers };
}
  setFormIoHeaders(): { headers: HttpHeaders } {
    const headers = new HttpHeaders({
      'x-jwt-token': sessionStorage.getItem('x-jwt-token') || '',
    });
    return { headers };
  }
  downloadDashboardCSV(endPoints: string, item: string): Observable<any> {
    const isCsv = true;
    return this.http.get(this.baseURL + endPoints + '/' + item, this.setHeaders(isCsv, 'csv'));
  }

  loginService(data: any): Observable<any>{
    return this.http.post(this.baseURL + 'auth/login', data);
  }

  loginFormIOservice(data: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, data, {...this.setHeaders(), observe: 'response'});
  }

  createNewFormIO(data: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, data, this.setHeadersJwt());
  }

  getAllFormList(payload: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, payload, this.setHeadersJwt());
  }

  logoutService(): Observable<any>{
    return this.http.post(this.baseURL + 'auth/logout', '', this.setHeaders());
  }

  // get impact data
  impactStoriesData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/impactstories?fetched=all', this.setHeaders());
  }

  impactStoriesMasterData(page: any, searchString: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchString === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `impactstories/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `impactstories/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `impactstories/list?page=${page}&fetched=all&searchKey=${searchString}`, this.setHeaders());
    }
  }

  resourceCenterData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/category?fetched=all', this.setHeaders());
  }

  resourceCenterMasterData(
    page: any, type: any = '', searchString: any = '', isDropDown: boolean, sortingOrder: string = '', columnName: string = ''
  ): Observable<any> {
    if (searchString === '' && !isDropDown && !sortingOrder?.length){
      return this.http.get(this.baseURL + `category/list?fetched=all&types=${type}`, this.setHeaders());
    }
    else if (isDropDown){
      return this.http.get(this.baseURL + `category/list?fetched=all&types=${type}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `category/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());

    }
    else{
      return this.http.get(
        this.baseURL + `category/list?page=${page}&types=${type}&fetched=all&searchKey=${searchString}`,
        this.setHeaders()
      );
    }
  }

  // Glossary data
  glossaryData(page: any, searchString: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchString === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `user/glossary?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `user/glossary?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `user/glossary?page=${page}&searchKey=${searchString}`, this.setHeaders());
    }
  }

  glossaryMasterData(page: any, searchString: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{

    if (searchString === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `glossary/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `glossary/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `glossary/list?page=${page}&fetched=all&searchKey=${searchString}`, this.setHeaders());
    }
  }

  homePageData(pageName: any = ''): Observable<any>{
    if (pageName){
      return this.http.get(this.baseURL + 'user/cms' + '?fetched=all', this.setHeaders());
    }else{
      return this.http.get(this.baseURL + 'user/cms', this.setHeaders());
    }
  }

  homePageMasterData(
    page: any, searchString?: any, sortingOrder: string = '', columnName: string = '', currentPage: string = ''
  ): Observable<any> {
    if (searchString === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `cms/list?page=${page}&currentPage=${currentPage}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `cms/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `cms/list?page=${page}&fetched=all&searchKey=${searchString}`, this.setHeaders());
    }
  }

  aboutUsMasterData(payloadData?: any, id?: any, isEditMode: boolean = false): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + `aboutUs/update/${id}`, payloadData, this.setHeaders());
    }else{
      return this.http.get(this.baseURL + `aboutUs/list`, this.setHeaders());
    }
  }

  employeeData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/employee', this.setHeaders());
  }

  inquiryMasterData(page: any, searchString: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchString === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `inquiry/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `inquiry/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());

    }
    else{
      return this.http.get(this.baseURL + `inquiry/list?page=${page}&fetched=all&searchKey=${searchString}`, this.setHeaders());
    }
  }

  adminListDetail(body: any): Observable<any>{
    const endpoint = `communication/create`;

    return this.http.post(this.baseURL + endpoint, body, this.getToken() ? this.setHeaders() : {});
  }

  contactUsInfo(data: any): Observable<any>{
    return this.http.post(this.baseURL + 'user/inquiry', data, this.setHeaders());
  }

  subscribeUser(data: any): Observable<any>{
    return this.http.post(this.baseURL + 'user/subscribe', data, this.setHeaders());
  }

  getSubCategoryData(catID: any): Observable<any>{
    return this.http.get(this.baseURL + 'user/subcategory/' + catID, this.setHeaders());
  }

  deleteLineItems(endPoints: string, lineItemID: number): Observable<any>{
    return this.http.delete(this.baseURL + endPoints + lineItemID, this.setHeaders());
  }

  uploadImage(body: any): Observable<any>{
    return this.http.post(this.baseURL + 'getS3Url', body);
  }

  createCms(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'cms/update/' + lineItemID, body, this.setHeaders());
    }else{
      return this.http.post(this.baseURL + 'cms/create', body, this.setHeaders());
    }
  }

  createCategory(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'category/update/' + lineItemID, body, this.setHeaders());
    }else{
      return this.http.post(this.baseURL + 'category/create', body, this.setHeaders());
    }
  }

  createSubCategory(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'subcategory/update/' + lineItemID, body, this.setHeaders());
    }else{
      return this.http.post(this.baseURL + 'subcategory/create', body, this.setHeaders());
    }
  }

  createSubCatReport(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'subcategoryreport/update/' + lineItemID, body, this.setHeaders());
    }else{
      return this.http.post(this.baseURL + 'subcategoryreport/create', body, this.setHeaders());
    }
  }

  createImpactStory(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'impactstories/update/' + lineItemID, body, this.setHeaders());
    }else{
      return this.http.post(this.baseURL + 'impactstories/create', body, this.setHeaders());
    }
  }

  createGlossary(body: any, lineItemID: any, isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'glossary/update/' + lineItemID, body, this.setHeaders());
    }
    else{
      return this.http.post(this.baseURL + 'glossary/create', body, this.setHeaders());
    }
  }

  imagePUTapi(imgURL: any, file: any): Observable<any>{
    return this.http.put(imgURL, file);
  }


  updateCMSlineitem(endPoints: string, body: any, lineItemID: any): Observable<any>{
    return this.http.post(this.baseURL + endPoints + lineItemID, body, this.setHeaders());
  }

  getSubscriberData(searchString: any, page: number, orderSorting?: any, key?: any): Observable<any>{
    if (searchString === '' && !orderSorting){
      return this.http.get(this.baseURL + 'subscribe/list?page=' + page, this.setHeaders());
    } else if (orderSorting){
      return this.http.get(this.baseURL + `subscribe/list?page=${page}&order=${orderSorting}&key=${key}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `subscribe/list?searchKey=${searchString}`, this.setHeaders());
    }
  }

  getDocumentsData(lineItemID: any): Observable<any>{
    return this.http.get(this.baseURL + 'user/subcategoryreport/' + lineItemID, this.setHeaders());
  }

  getSubCategoryAllData(
    page: any, searchedValue: any, isDropDown: boolean, sortingOrder: string = '', columnName: string = ''
  ): Observable<any> {
    if (searchedValue === '' && !isDropDown && !sortingOrder?.length){
      return this.http.get(this.baseURL + `subcategory/list?page=${page}`, this.setHeaders());
    }
    else if (isDropDown){
      return this.http.get(this.baseURL + `subcategory/list?fetched=all`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `subcategory/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());

    }
    else{
      return this.http.get(this.baseURL + `subcategory/list?fetched=all&searchKey=${searchedValue}`, this.setHeaders());
    }
  }

  getSubCategoryReportAllData(page: any, searchedValue: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchedValue === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `subcategoryreport/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder))
    {
      return this.http.get(this.baseURL + `subcategoryreport/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `subcategoryreport/list?fetched=all&searchKey=${searchedValue}`, this.setHeaders());
    }
  }

// --------------------------------------------------------------------------------------------------------
  // DASHBOARD SERVICE FUNCTIONS STARTS FROM HERE
  getStatesGeoJson(): Observable<any> {
    return this.http.get('../assets/customJson/custom.geo.json');
  }

  // DASHBOARD SERVICE FUNCTIONS ENDS HERE
// -----------------------------------------------------------------------------------------------------------

  getFormQuestions(url: string, formId: number, isMonthly: string = '', factoryParams: string = ''): Observable<any>{
    if (formId === 3) {
    formId = 2;
    }
    return this.http.get(this.baseURL + url + formId + (isMonthly ? '&' + isMonthly : '') + factoryParams, this.setHeaders());
  }

  submitFormAnswers(body: any, url: string, isMonthly: string = ''): Observable<any>{
       return this.http.post(this.baseURL + url + (isMonthly ? '?' + isMonthly : ''), body, this.setHeaders());
  }

  teamAllData(page: any, searchedValue: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchedValue === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `teammember/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `teammember/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `teammember/list?fetched=all&searchKey=${searchedValue}`, this.setHeaders());
    }
  }

  partnerAllData(page: any, searchedValue: any, sortingOrder: string= '', columnName: string= ''): Observable<any>{
    if (searchedValue === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `partners/list?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `partners/list?page=${page}&key=${columnName}&order=${sortingOrder}`, this.setHeaders());

    }
    else{
      return this.http.get(this.baseURL + `partners/list?fetched=all&searchKey=${searchedValue}`, this.setHeaders());
    }
  }

  createTeamMember(body: any, lineItemID: any = '', isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'teammember/update/' + lineItemID, body, this.setHeaders());
    }
    else{
      return this.http.post(this.baseURL + 'teammember/create', body, this.setHeaders());
    }
  }

  createNewPartner(body: any, lineItemID: any = '', isEditMode: boolean): Observable<any>{
    if (isEditMode){
      return this.http.post(this.baseURL + 'partners/update/' + lineItemID, body, this.setHeaders());
    }
    else{
      return this.http.post(this.baseURL + 'partners/create', body, this.setHeaders());
    }
  }

  removeTeamMember(id: any, bodyData: any): Observable<any>{
    return this.http.post(this.baseURL + 'teammember/update/' + id, bodyData, this.setHeaders());
  }


  ourPartnerData(): Observable<any>{
    return this.http.get(this.baseURL + '', this.setHeaders());
  }

  aboutUsData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/cms?sectionId=2', this.setHeaders());
  }

  ourPartnerPageData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/cms?sectionId=4', this.setHeaders());
  }

  countryData(countryId: number = 0): Observable<any>{
    const filter = countryId ? '?id=' + countryId : '';
    return this.http.get(this.baseURL + 'country/list' + filter, this.setHeaders());
  }
  createSignUpUser(data: any): Observable<any>{
    return this.http.post(this.baseURL + 'user/register', data, this.setHeaders());
  }
  forgetPassworEmailRequest(data: any): Observable<any>{
    return this.http.post(this.baseURL + 'user/sendmail', data, this.setHeaders());
  }
  handlehttpError(request: HttpErrorResponse): Observable<never> {
    return throwError(request.error ? request.error : request.message ? request.message : 'SERVER ERROR');
}

  getProgramFormListing(
    url: string = 'programform/list?page=', page: any, roleId: any, id: any, formId: any, sortingOrder: string = '', columnName: string = ''
  ): Observable<any> {
    if (formId === '3'){
      page = page === -1 ? '&is_month=true ' : page + '&is_month=true';
    }

    if (page === -1){
      return this.http.get(this.baseURL + url, this.setHeaders());
    }
    else{
      if (['DESC', 'ASC'].includes(sortingOrder)){
        return this.http.get(this.baseURL + url + page + `&key=${columnName}&order=${sortingOrder}`, this.setHeaders());
      }
      return this.http.get(this.baseURL + url + page, this.setHeaders());
    }
  }

  getPageDetails(sectionId: number): Observable<any>{
    return this.http.get(this.baseURL + 'user/cms?sectionId=' + sectionId, this.setHeaders());
  }
  // download Csv
  downloadCSVFile(data: any, fileName: string = 'csvFile.csv'): void {

    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  getSecratKey(secratKey: any, password: any): string {
    const ciphertext = Crypto.HmacSHA256(password, secratKey).toString();
    return ciphertext;
  }

  captchaData(): Observable<any>{
    return this.http.get(this.baseURL + 'user/captcha/create');
  }
  refreshCaptch(captchId: string): Observable<any> {
    return this.http.get(this.baseURL + 'user/captcha/refresh/' + captchId, this.setHeadersCaptcha());
  }
  destroyRefreshCaptcha(captchId: string): Observable<any> {
    return this.http.post(this.baseURL + 'user/captcha/destroy/' + captchId, this.setHeadersCaptcha());
  }
  getRoleDataById(id: string): Observable<any> {
    return this.http.get(this.baseURL + `authenication/view?role_id=${id}`, this.setHeaders());
  }
  actionTablePermission(actionArray: any[], permissionArray: any): any[] {
    return actionArray.map((mainItem: any) => {
      permissionArray?.authentication?.forEach((secondaryItem: any) => {
        if (mainItem.key === secondaryItem.key){
          mainItem.isPermission = secondaryItem.isAction;
        }
      });

      return mainItem;
    });
  }
  direactUrlAccess(data: string[], permissionArray: any): boolean{
   return permissionArray?.authenicationJson.some((el: any) =>
    data.includes(el.model) &&
    ((el?.isAction || el?.is_checked) || (el?.authentication?.length && el?.authentication.some((e: any) => e?.isAction)))
   );
  }
  // dashboard releated api intergations
  socailImpactCardDetails(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/social-impact/card', this.setHeaders());
  }
  socailImpactCardDetailsForPieChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/social-impact/pie-chart', this.setHeaders());
  }
  environmentalImpactCardDetails(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/environmental-impact/card', this.setHeaders());
  }
  environmentalImpactCardDetailsForPieChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/environmental-impact/pie-chart', this.setHeaders());
  }
  environmentalImpactCardDetailsForDoughnutChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/environmental-impact/donut-chart', this.setHeaders());
  }
  environmentalImpactCardDetailsForBarChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/environmental-impact/bar-chart', this.setHeaders());
  }
  environmentalImpactCardDetailsForTreeChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/environmental-impact/tree-map', this.setHeaders());
  }
  socailIpmactDetailsForStackedBarChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/social-impact/stacked-bar-chart', this.setHeaders());
  }
  socailIpmactDetailsForBarChart(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/social-impact/bar-chart', this.setHeaders());
  }
  socailIpmactDetailsForTable(): Observable<any> {
       return this.http.get(this.baseURL + 'programview/social-impact/table', this.setHeaders());
  }

  details(section: string = '', item: string = '', countryId: string= ''): Observable<any> {

    return this.http.get(this.baseURL + section + '/' + item + countryId, this.getToken() ? this.setHeaders() : {});
  }
  sectorNameDetails(
    page: any = 1, searchString: string = '', id: string, sortingOrder: string= '', columnName: string= ''
  ): Observable<any> {
    if (id){
      return this.http.get(
        environment.baseURL + 'sector/list?country_id=' + id + '&page=' + page + '&searchKey=' + searchString,
        this.getToken() ? this.setHeaders() : {}
      );
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
        return this.http.get(
          environment.baseURL + 'sector/list' + `?page=${page}&key=${columnName}&order=${sortingOrder}`,
          this.getToken() ? this.setHeaders() : {}
        );
    }

    else{
      return this.http.get(
        environment.baseURL + 'sector/list?page='  + page + '&searchKey=' + searchString,
        this.getToken() ? this.setHeaders() : {}
      );
    }

  }

  msmeNameDetails(
    page: any = 1, searchString: string = '', id: string, sortingOrder: string= '', columnName: string = ''
  ): Observable<any> {
    if (id){
    return this.http.get(
      environment.baseURL + 'msme/list?sector_id=' + id + '&page=' + page + '&searchKey=' + searchString,
      this.getToken() ? this.setHeaders() : {}
    );
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(
        environment.baseURL + 'msme/list' + `?page=${page}&key=${columnName}&order=${sortingOrder}`,
        this.getToken() ? this.setHeaders() : {}
      );
    }
    else{
      return this.http.get(
        environment.baseURL + 'msme/list?' + '&page=' + page + '&searchKey=' + searchString,
        this.getToken() ? this.setHeaders() : {}
      );
    }
  }

  // download excel format
  downloadDashboardXLS(): Observable<any> {
    const isCsv = false;
    return this.http.get(this.baseURL + 'programform/csv', this.setHeaders());
  }

  downloadExcelFile(data: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(data, `${fileName}.xlsx`);
  }


  // download Pdf Formate'
  downloadDashboardPDF(): Observable<any> {
    const isCsv = false;
    return this.http.get(this.baseURL + 'programform/csv', this.setHeaders(isCsv, 'pdf'));
  }

  downloadPDFFile(res: any, fileName: string= 'pdfFormate'): void {
   const blob = new Blob([res], { type: 'application/pdf' });
   const pdfUrl = window.URL.createObjectURL(blob);

   const pdfLink = document.createElement('a');
   pdfLink.href = pdfUrl;
   pdfLink.download = `${fileName}.pdf`;
   pdfLink.click();
   document.body.removeChild(pdfLink);
  }

  communicaionList(
    id: any, filterParam: any = '', page: number = 1, isFetchAll: boolean= false, status: any = '',
    userId: any = '', searchedValue: any = '', starMessage: boolean = false
  ): Observable<any>{
    if (id){
      return this.http.get(this.baseURL + `communication/list?id=${id}`, this.setHeaders());
    }
    else if (status){
      let endpoints = '';
      if (status === 'send'){
        endpoints = `fetched=all&sender_id=${this.userData.id}`;
        endpoints = searchedValue !== '' ? `${endpoints}&searchKey=${searchedValue}` : endpoints;
        return this.http.get(this.baseURL + `communication/list?${endpoints}`, this.setHeaders());
      }else{
        endpoints = `fetched=all&is_received=true&sender_id=${userId}`;
        endpoints = searchedValue !== '' ? `${endpoints}&searchKey=${searchedValue}` : endpoints;
        return this.http.get(this.baseURL + `communication/list?${endpoints}`, this.setHeaders());
      }
    }
    else{
      if (filterParam){
        return this.http.get(this.baseURL + `communication/list?${filterParam}`, this.setHeaders());
      } else if (isFetchAll && page === 0){
        return this.http.get(this.baseURL + `communication/list?is_received=true`, this.setHeaders());
      }
      else{
        return this.http.get(this.baseURL + `communication/list?page=${page}`, this.setHeaders());
      }
    }
  }

  communicationUpdate(lineitemID: any, body: any): Observable<any>{
    return this.http.post(this.baseURL + `communication/update/${lineitemID}`, body, this.setHeaders());
  }

  communicationmapper(body: any): Observable<any>{
    return this.http.post(this.baseURL + `communicationmapper/create`, body, this.setHeaders());
  }
  resetPassword(body: any): Observable<any>{
    return this.http.post(this.baseURL + `user/forgotpassword`, body);
  }

  markAllasRead(body: any): Observable<any>{
    return this.http.post(this.baseURL + `communication/create/ip`, body, this.setHeaders());
  }
  timeLine(params: any= {}): Observable<any>{
    if (Object.keys(params).length){
      return this.http.get(this.baseURL + `programview/social-impact/timeline?month=${params?.month}&financial_year=${params?.financial_year}`, this.getToken() ? this.setHeaders() : {});
    }else{
      return this.http.get(this.baseURL + `programview/social-impact/timeline`, this.getToken() ? this.setHeaders() : {});
    }
  }

  // ------------------------------------------------------------------------------------------------------------------
  // Form.IO APIs

  formIOSetHeaders(): { headers: HttpHeaders } {
    const headers = new HttpHeaders({
        'x-jwt-token': '',
    });
    return {headers};
  }
  publishForms(body: any): Observable<any>{
    return this.http.post(this.formIoBaseURL + `form`, body, this.formIOSetHeaders());
  }

  getIpsaFormStructure(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body, this.setHeadersJwt());
  }

  postIpsaFormData(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body, this.setHeadersJwt());
  }

  prefillFormIO(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body, this.setHeadersJwt());
  }
  formGetMethod(endPoints: string, queryParam: any = {}): any {
    return this.http.get(
      `${this.baseURL}${endPoints}`,
      {
        params: queryParam,
        ...this.setHeaders()
      },

    );
  }
  formPostMethod(body: any, endPoints: string): any {
    return this.http.post(
      `${this.baseURL}${endPoints}`,
      body,
      this.setHeaders()
    );
  }
  formUpdateMethod(body: any, endPoints: string, id: string, action?: any): any {
    if (action === 'deleteAction'){
      return this.http.post(`${this.baseURL}${endPoints}/${id}?deleted=true`, body, this.setHeaders());
    }else{
      return this.http.post(`${this.baseURL}${endPoints}/${id}`, body, this.setHeaders());
    }
  }

  registerIpsaUser(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body, this.setHeaders());
  }

  msmeDashboardDetails(
    page: any = 1, searchString: string = '', id: string, sortingOrder: string= '', columnName: string= ''
  ): Observable<any> {
    let params = `?page${page}&isDashboard=true`;

    if (id){
      params += `&country_id=${id}`;
    }
    if (searchString){
      params += `&searchKey=${searchString}`;
    }
    if (['DESC', 'ASC'].includes(sortingOrder)){
      params +=  `&key=${columnName}&order=${sortingOrder}`;
    }

    return this.http.get(
      environment.baseURL + 'msme/list?page=' + params,
      this.getToken() ? this.setHeaders() : {}
    );

  }

  targettedUserData(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body);
  }

  updateUserForIpsa(body: any): Observable<any>{
    return this.http.post(this.baseURL + `ipsa/create`, body);
  }

  getAllYears(currentForm: any): Observable<any>{
    return this.http.get(this.baseURL + `year/list?${currentForm}=true`, this.setHeaders());
  }

  getMonths(params?: any, type: any = ''): Observable<any>{
    if (type === 'yearChange'){
      return this.http.get(this.baseURL + `month/list?${params}`, this.setHeaders());
    }else {
      return this.http.get(this.baseURL + `month/list`, this.setHeaders());
    }
  }

  downloadImage(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  allAdminMenbers(label: string, page: number = 1, searchedValue: string = '', id: any = '', sortingOrder: string = '', culomnName: string = ''): Observable<any>{
    const endpoint = label === 'Admin' ? `admin/list` : `msmes/list`;
    if (searchedValue === '' && !sortingOrder?.length){
      return this.http.get(this.baseURL + `${endpoint}?page=${page}`, this.setHeaders());
    }
    else if (['DESC', 'ASC'].includes(sortingOrder)){
      return this.http.get(this.baseURL + `${endpoint}?page=${page}&key=${culomnName}&order=${sortingOrder}`, this.setHeaders());
    }
    else{
      return this.http.get(this.baseURL + `${endpoint}?fetched=all&searchKey=${searchedValue}`, this.setHeaders());
    }
  }

  verifyRegistrationEmail(email: string): Observable<any> {
    return this.http.get(this.baseURL + `interests/check-email?email=${encodeURIComponent(email)}`);
  }
}
